import CustomCard from '../../../components/CustomCard.tsx'
import { TextBoxComponent } from '@syncfusion/ej2-react-inputs'
import { useFormContext } from 'react-hook-form'

export const BankData = () => {
  const { register } = useFormContext()

  return (
    <CustomCard header="Bankdaten">
      <div className="formRow">
        <TextBoxComponent placeholder="Kontoinhaber" floatLabelType="Always" {...register('accountOwner')} />
        <TextBoxComponent placeholder="Bankverbindung" floatLabelType="Always" {...register('bankName')} />
      </div>
      <div className="formRow">
        <TextBoxComponent placeholder="IBAN" floatLabelType="Always" {...register('iban')} />
        <TextBoxComponent placeholder="BIC/Swift" floatLabelType="Always" {...register('bic')} />
      </div>
    </CustomCard>
  )
}
